import React from 'react';
import LottieWrapper from './lottie-wrapper';
import ThreeDotRevolvingLottieJSON from '../assets/fibo/three-dot-revolving-loader.json';

const FullScreenBackdropLoader = ({ isLoading = false }) => {
  return (
    <>
      {isLoading ? (
        <>
          <div className="res150-overlay fixed top-0 left-0 right-0 bottom-0 w-full h-full  overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center z-[100]"></div>
          <div
            className="res150-overlay fixed top-0 left-0 right-0 bottom-0 w-full h-full  overflow-hidden  opacity-100 flex flex-col items-center justify-center z-[105]"
            id="three-dot-loader"
          >
            <LottieWrapper
              animationData={ThreeDotRevolvingLottieJSON}
              width={'150px'}
              height={'150px'}
            />
          </div>
        </>
      ) : null}
    </>
  );
};

export default FullScreenBackdropLoader;
